import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './i18n';
import './index.css';
import { installClickSound } from '@/lib/clickSound';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Every press and every mark clicks (owner, 2026-09-08). One listener on
// the document, for the life of the page.
installClickSound();

// PWA service worker (public/sw.js): caches the static shell ONLY — /api and
// /socket.io are never intercepted, so no money figure can ever be served
// stale from a cache. Production builds only: in dev it would fight Vite's
// module server and hand back yesterday's code after every edit.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // The app is fully functional without it; installability is all that is
      // lost, and a console error here would just alarm whoever is at the till.
    });
  });
}
